import { LoaderFunctionArgs, redirect } from 'react-router-dom'
import paymentPageLoader from './paymentPageLoader'
import getTransaction from '../api/getTransaction'
import { PaymentPageInfo } from '../types/paymentPageInfo'
import { RequisiteP2PTransactionResult } from '../types/TransactionResult'

export interface P2PPayPageData {
    paymentPageInfo: PaymentPageInfo
    transaction: RequisiteP2PTransactionResult
}

const p2pPayPageLoader = async (args: LoaderFunctionArgs): Promise<P2PPayPageData> => {
    const { paymentPageId, transactionId } = args.params

    if (!paymentPageId || !transactionId) {
        throw new Response('Payment page ID and transaction ID are required', { status: 400 })
    }

    const [paymentPageInfo, transaction] = await Promise.all([
        paymentPageLoader({...args, params: { ...args.params, method: 'p2p' }}),
        getTransaction(paymentPageId, transactionId),
    ])

    if (transaction.type !== 'init') {
        throw redirect(`/result/${paymentPageInfo.id}/${transaction.transactionId}`)
    }

    return { paymentPageInfo, transaction: transaction as RequisiteP2PTransactionResult }
}

export default p2pPayPageLoader
